// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___sXljA","slider":"slider___bP51A","slide":"slide___OrZiK"};